"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.padNumStart = exports.padNumEnd = exports.isStringPurelyNumeric = exports.isNum = exports.isFraction = exports.formatVolt = exports.formatStrVolt = exports.formatStrStationId = exports.formatStrNumber = exports.formatStrMillivolt = exports.formatStrMiles = exports.formatStrGeoNum = exports.formatStationId = exports.formatPercent = exports.formatNumber = exports.formatMillivolt = exports.formatMiles = exports.formatGeoNum = exports.default = exports.TESTS = void 0;
const DEFAULT_SCALE = {
  GEONUM: 6,
  MILES: 4,
  MILLIVOLT: 2,
  NUMBER: 2,
  VOLT: 5,
  STATIONID: 2,
  PERCENT: 2
};

// expects boolean
const DEFAULT_PAD_SCALE = {
  GEONUM: undefined,
  MILES: undefined,
  MILLIVOLT: undefined,
  NUMBER: undefined,
  VOLT: undefined,
  STATIONID: undefined
};

// expects numeric (pad count)
const DEFAULT_PAD_START = {
  GEONUM: undefined,
  MILES: undefined,
  MILLIVOLT: undefined,
  NUMBER: undefined,
  VOLT: undefined,
  STATIONID: 4
};

// expects numeric (pad count)
const DEFAULT_PAD_END = {
  GEONUM: undefined,
  MILES: undefined,
  MILLIVOLT: undefined,
  NUMBER: undefined,
  VOLT: undefined,
  STATIONID: undefined
};
const isDefined = val => val !== null && val !== undefined;
const stripSpecialChars = val => {
  if (isDefined(val) && val.toString) {
    return val.toString().replace(/,|\+/gi, '');
  }
  return val;
};
const isEmptyString = val => typeof val === 'string' && val.trim() === '';
const isNum = val => !Number.isNaN(parseFloat(val, 10));
exports.isNum = isNum;
const isStringPurelyNumeric = v => {
  // eslint-disable-next-line no-useless-escape
  const reOnlyValidChars = /^[\-\,\.\d]+$/i;
  const reHasNum = /\d/i;
  if (typeof v === 'string') {
    return reOnlyValidChars.test(v) && reHasNum.test(v);
  }
  return typeof v === 'number';
};
exports.isStringPurelyNumeric = isStringPurelyNumeric;
const isFraction = v => {
  const isPossibleFraction = typeof v === 'string' && v.indexOf('/') > -1;
  if (!isPossibleFraction) {
    return false;
  }
  const parts = v.split('/');
  if (parts.length !== 2) {
    return false;
  }
  return isNum(parts[0]) && isNum(parts[1]);
};
exports.isFraction = isFraction;
const padNumStart = function (val, cnt) {
  let {
    char = 0
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!isDefined(val) || !val.toString || !isNum(val) || !isNum(cnt) || !isDefined(char)) {
    return val;
  }
  const [num, dec] = stripSpecialChars(val).split('.');
  const isNeg = Number.parseFloat(num) < 0;
  const strNum = Math.abs(Number.parseFloat(num)).toString();
  let result = strNum.padStart(cnt, char);
  if (isDefined(dec)) {
    result = `${result}.${dec}`;
  }
  if (isNeg) {
    result = `-${result}`;
  }
  return result;
};
exports.padNumStart = padNumStart;
const padNumEnd = function (val, cnt) {
  let {
    char = 0
  } = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (!isDefined(val) || !val.toString || !isNum(val) || !isNum(cnt) || !isDefined(char)) {
    return val;
  }
  const [num = 0, dec = char] = stripSpecialChars(val).split('.');
  const strNum = isEmptyString(num) ? '0' : num.toString();
  return `${strNum}.${dec.toString().padEnd(cnt, char)}`;
};
exports.padNumEnd = padNumEnd;
const formatNumber = function (val) {
  let {
    scale = DEFAULT_SCALE.NUMBER
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isFraction(val)) {
    const [numerator, denominator] = val.split('/');
    const n = formatNumber(numerator, {
      scale: 12
    });
    const d = formatNumber(denominator, {
      scale: 12
    });
    // eslint-disable-next-line no-param-reassign
    val = !d ? 0 : n / d;
  }
  if (isNum(val)) {
    return Number.parseFloat(Number.parseFloat(stripSpecialChars(val)).toFixed(scale));
  }
  return val;
};

// @todo - create automated tests for formatPercent
// @todo - create implementation and tests for formatStrPercent
exports.formatNumber = formatNumber;
const formatPercent = function (val) {
  let {
    scale = DEFAULT_SCALE.PERCENT
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  if (isFraction(val)) {
    return formatNumber(val, {
      scale: scale + 2
    }) * 100;
  }
  return formatNumber(val, {
    scale
  });
};
exports.formatPercent = formatPercent;
const withFraction = fn => function () {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  const [v, ...params] = args;
  if (isFraction(v)) {
    const [numerator, denominator] = v.split('/');
    const n = fn(numerator, ...params);
    const d = fn(denominator, ...params);
    return `${n}/${d}`;
  }
  return fn(v, ...params);
};
const formatStrNumber = function (val) {
  let {
    scale,
    padScale = false,
    padStart,
    padEnd
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const strVal = isDefined(val) ? val.toString().trim() : '';
  let strParts = strVal.split(' ').filter(v => isDefined(v)).map(v =>
  // eslint-disable-next-line no-shadow
  withFraction((v, _ref) => {
    let {
      scale
    } = _ref;
    return formatNumber(v, {
      scale
    });
  })(v, {
    scale
  }));
  if (padScale && scale) {
    strParts = strParts.map(v =>
    // eslint-disable-next-line no-shadow
    withFraction((v, scale) => isNum(v) ? padNumEnd(v, scale) : v)(v, scale));
  } else if (isDefined(padEnd)) {
    strParts = strParts.map(v =>
    // eslint-disable-next-line no-shadow
    withFraction((v, padEnd) => isNum(v) ? padNumEnd(v, padEnd) : v)(v, padEnd));
  }
  if (isDefined(padStart)) {
    strParts = strParts.map(v =>
    // eslint-disable-next-line no-shadow
    withFraction((v, padStart) => isNum(v) ? padNumStart(v, padStart) : v)(v, padStart));
  }
  return strParts.join(' ');
};
exports.formatStrNumber = formatStrNumber;
const formatGeoNum = function (val) {
  let {
    scale = DEFAULT_SCALE.GEONUM
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(val, {
    scale
  });
};
exports.formatGeoNum = formatGeoNum;
const formatStrGeoNum = function (val) {
  let {
    scale = DEFAULT_SCALE.GEONUM,
    padScale = DEFAULT_PAD_SCALE.GEONUM,
    padStart = DEFAULT_PAD_START.GEONUM,
    padEnd = DEFAULT_PAD_END.GEONUM
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatStrNumber(val, {
    scale,
    padScale,
    padStart,
    padEnd
  });
};
exports.formatStrGeoNum = formatStrGeoNum;
const formatMillivolt = function (val) {
  let {
    scale = DEFAULT_SCALE.MILLIVOLT
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(val, {
    scale
  });
};
exports.formatMillivolt = formatMillivolt;
const formatStrMillivolt = function (val) {
  let {
    scale = DEFAULT_SCALE.MILLIVOLT,
    padScale = DEFAULT_PAD_SCALE.MILLIVOLT,
    padStart = DEFAULT_PAD_START.MILLIVOLT,
    padEnd = DEFAULT_PAD_END.MILLIVOLT
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatStrNumber(val, {
    scale,
    padScale,
    padStart,
    padEnd
  });
};
exports.formatStrMillivolt = formatStrMillivolt;
const formatVolt = function (val) {
  let {
    scale = DEFAULT_SCALE.VOLT
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(val, {
    scale
  });
};
exports.formatVolt = formatVolt;
const formatStrVolt = function (val) {
  let {
    scale = DEFAULT_SCALE.VOLT,
    padScale = DEFAULT_PAD_SCALE.VOLT,
    padStart = DEFAULT_PAD_START.VOLT,
    padEnd = DEFAULT_PAD_END.VOLT
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatStrNumber(val, {
    scale,
    padScale,
    padStart,
    padEnd
  });
};
exports.formatStrVolt = formatStrVolt;
const formatMiles = function (val) {
  let {
    scale = DEFAULT_SCALE.MILES
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(val, {
    scale
  });
};
exports.formatMiles = formatMiles;
const formatStrMiles = function (val) {
  let {
    scale = DEFAULT_SCALE.MILES,
    padScale = DEFAULT_PAD_SCALE.MILES,
    padStart = DEFAULT_PAD_START.MILES,
    padEnd = DEFAULT_PAD_END.MILES
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatStrNumber(val, {
    scale,
    padScale,
    padStart,
    padEnd
  });
};
exports.formatStrMiles = formatStrMiles;
const formatStationId = function (val) {
  let {
    scale = DEFAULT_SCALE.STATIONID
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return formatNumber(val, {
    scale
  });
};
exports.formatStationId = formatStationId;
const formatStrStationId = function (val) {
  let {
    scale = DEFAULT_SCALE.STATIONID,
    padScale = DEFAULT_PAD_SCALE.STATIONID,
    padStart: paramPadStart = DEFAULT_PAD_START.STATIONID,
    padEnd = DEFAULT_PAD_END.STATIONID,
    unit = 'meters'
  } = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  const POST_PLUS_DIGIT_COUNT = unit === 'feet' ? 2 : 3;
  const padStart = Math.max(DEFAULT_PAD_START.STATIONID, paramPadStart);
  const baseResult = formatStrNumber(val, {
    scale,
    padScale,
    padStart,
    padEnd
  });
  const strParts = baseResult.split(' ').filter(v => !!v).map(v => {
    if (!isNum(v)) {
      return v;
    }
    const [num, dec] = v.toString().split('.');
    const strNum = num.toString();

    // format number
    const numPrePlus = strNum.substr(0, strNum.length - POST_PLUS_DIGIT_COUNT);
    const numPostPlus = strNum.substr(strNum.length - POST_PLUS_DIGIT_COUNT, strNum.length);
    const formattedNum = `${numPrePlus}+${numPostPlus}`;

    // format decimal
    if (dec) {
      return `${formattedNum}.${dec}`;
    }
    return formattedNum;
  });
  return strParts.join(' ');
};
exports.formatStrStationId = formatStrStationId;
const defaultExport = {
  isNum,
  isFraction,
  isStringPurelyNumeric,
  formatStrNumber,
  formatNumber,
  formatPercent,
  formatGeoNum,
  formatStrGeoNum,
  formatVolt,
  formatStrVolt,
  formatMillivolt,
  formatStrMillivolt,
  formatMiles,
  formatStrMiles,
  formatStationId,
  formatStrStationId,
  padNumStart,
  padNumEnd
};
const TESTS = {
  ...defaultExport,
  DEFAULT_SCALE
};
exports.TESTS = TESTS;
var _default = defaultExport;
exports.default = _default;